const monetary = (value, currencyId) => {
  if (!value || !currencyId || !value[currencyId]) {
    return '-';
  }

  if (value[currencyId].value === 0) {
    return 'Zdarma';
  }

  return value[currencyId].formatted;
};

const multilingual = (value, languageId) => {
  if (!value || !languageId || !value[languageId]) {
    return '-';
  }

  return value[languageId];
};

export default { monetary, multilingual };
